/* src/app/admin/admin.component.css */
.block {
  display: block;
}
.link {
  color: #001F3F;
  font-size: 20px;
  display: inline-block;
  margin-top: 10px;
  margin-bottom: 5px;
  margin-right: 10px;
}
.custom-table .p-datatable-thead > tr > th {
  background: #e9ecef !important;
  color: #212529 !important;
  font-weight: 600 !important;
  text-align: center !important;
  border: 1px solid #dee2e6 !important;
  padding: 12px 32px !important;
  font-size: 0.95rem !important;
  min-width: 80px !important;
}
.custom-table .p-datatable-thead > tr > th.p-highlight {
  background: #e7f1ff !important;
  color: #0d6efd !important;
}
.custom-table .p-datatable-thead > tr > th.p-sortable-column:hover {
  background: #dee2e6 !important;
}
.custom-table .p-datatable-thead > tr > th[aria-sort=ascending],
.custom-table .p-datatable-thead > tr > th[aria-sort=descending] {
  background: #0d6efd !important;
  color: #ffffff !important;
}
.custom-table .p-datatable-tbody > tr > td {
  border: 1px solid #dee2e6 !important;
  padding: 10px 32px !important;
  min-width: 80px !important;
}
.custom-table .p-datatable-tbody > tr:hover {
  background: #f8f9fa !important;
}
.custom-table {
  border: 1px solid #dee2e6 !important;
}
::ng-deep .custom-table .p-datatable-table {
  table-layout: auto !important;
}
::ng-deep .custom-table .p-datatable-thead > tr > th {
  min-width: 80px !important;
  width: auto !important;
  padding: 12px 32px !important;
  background: #e9ecef !important;
  color: #212529 !important;
  font-weight: 600 !important;
  text-align: center !important;
  border: 1px solid #dee2e6 !important;
  font-size: 0.95rem !important;
}
::ng-deep .custom-table .p-datatable-tbody > tr > td {
  min-width: 80px !important;
  width: auto !important;
  padding: 10px 32px !important;
  border: 1px solid #dee2e6 !important;
}
::ng-deep .custom-table .p-datatable-thead > tr > th.p-highlight {
  background: #e7f1ff !important;
  color: #0d6efd !important;
}
::ng-deep .custom-table .p-datatable-thead > tr > th.p-sortable-column:hover {
  background: #dee2e6 !important;
}
::ng-deep .custom-table .p-datatable-thead > tr > th[aria-sort=ascending],
::ng-deep .custom-table .p-datatable-thead > tr > th[aria-sort=descending] {
  background: #0d6efd !important;
  color: #ffffff !important;
}
::ng-deep .custom-table .p-datatable-tbody > tr:hover {
  background: #f8f9fa !important;
}
::ng-deep .custom-table .p-datatable-header {
  background: #e9ecef !important;
  border: 1px solid #dee2e6 !important;
  padding: 1rem !important;
}
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.table-toolbar .left,
.table-toolbar .right {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
::ng-deep .table-toolbar .p-select,
::ng-deep .table-toolbar .p-inputtext {
  border: 1px solid #dee2e6 !important;
  background: #ffffff !important;
}
::ng-deep .table-toolbar .p-inputgroup-addon {
  border: 1px solid #dee2e6 !important;
  background: #e9ecef !important;
  color: #495057 !important;
}
::ng-deep .custom-table .p-paginator {
  background: #e9ecef !important;
  border: 1px solid #dee2e6 !important;
  padding: 12px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
::ng-deep .custom-table .p-paginator .p-paginator-first,
::ng-deep .custom-table .p-paginator .p-paginator-prev,
::ng-deep .custom-table .p-paginator .p-paginator-next,
::ng-deep .custom-table .p-paginator .p-paginator-last,
::ng-deep .custom-table .p-paginator .p-paginator-page {
  margin: 0 4px !important;
  min-width: 36px !important;
  height: 36px !important;
  border: 1px solid #dee2e6 !important;
  background: #ffffff !important;
  color: #212529 !important;
}
::ng-deep .custom-table .p-paginator .p-paginator-page.p-highlight {
  background: #0d6efd !important;
  color: #ffffff !important;
  border-color: #0d6efd !important;
}
::ng-deep .custom-table .p-paginator .p-paginator-first:hover,
::ng-deep .custom-table .p-paginator .p-paginator-prev:hover,
::ng-deep .custom-table .p-paginator .p-paginator-next:hover,
::ng-deep .custom-table .p-paginator .p-paginator-last:hover,
::ng-deep .custom-table .p-paginator .p-paginator-page:hover {
  background: #f8f9fa !important;
  border-color: #0d6efd !important;
}
/*# sourceMappingURL=admin.component.css.map */
